// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"2a7f10dbd978d86c302c","303":"caacaacf57e1b7d96013","495":"f818dea155dd68a4fc5b"}[chunkId] + ".js";
};